import { render } from "./FrenDiski.vue?vue&type=template&id=53a2863e"
import script from "./FrenDiski.vue?vue&type=script&lang=js"
export * from "./FrenDiski.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__